<script>import { getContext } from "svelte";
import { createFieldContext } from "./helper/field.js";
export let name = void 0;
export const label = void 0;
export const callToInput = void 0;
export const assistText = void 0;
export const story = void 0;
export let value = void 0;
export let error = void 0;
export let disabled = false;
export const control = void 0;
export const locale = void 0;
export const context = void 0;
const contextKey = createFieldContext(name, value, error, disabled, value === void 0);
const ctx = getContext(contextKey);
$: {
  ctx.value.set(value);
  ctx.error.set(error);
  ctx.disabled.set(disabled);
  ctx.empty.set(value === void 0);
}
</script>

<input type="hidden" {value} {name} />
